export default __webpack_public_path__ + "media/builders/header-3ab617d8.png";